import baseScmService from 'services/baseScmService';

const classTemplateService = baseScmService.injectEndpoints({
  endpoints: (build) => ({
    createLectureTemplate: build.mutation({
      query: (lectureTemplate) => ({
        method: 'POST',
        url: '/lecture-templates/',
        body: {
          academy_topic: {
            title: lectureTemplate.academyTopicInput?.title,
            junction_number: lectureTemplate.academyTopicInput?.junction_number,
            academy_module_id:
              lectureTemplate.academyTopicInput?.academy_module?.id,
            bucket_id: lectureTemplate.academyTopicInput?.lecture_bucket?.id,
          },
          class_tag: lectureTemplate.classTag,
          course_group: lectureTemplate.courseGroup,
          pre_lecture_content: lectureTemplate.preLectureContent,
          post_lecture_content: lectureTemplate.postLectureContent,
          literature_resource: lectureTemplate.literatureResource,
          live_lecture: lectureTemplate.liveLecture,
          assignment: lectureTemplate.assignment,
          homework: lectureTemplate.homework,
          pre_read: lectureTemplate.preRead,
          academy_project: lectureTemplate.academyProject,
          bypass_live_lecture: lectureTemplate.byPassLiveLecture,
        },
      }),
    }),
    bulkUpdateLectureTemplates: build.mutation({
      query: ({ academyTopicId, bulkUpdateSyncType }) => ({
        method: 'PUT',
        url: `/lecture-templates/${bulkUpdateSyncType}`,
        body: {
          academy_topic_id: academyTopicId,
        },
      }),
      invalidatesTags: (result, error, { academyTopicId }) =>
        error ? [] : [{ type: 'AcademyTopic', id: academyTopicId }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useCreateLectureTemplateMutation,
  useBulkUpdateLectureTemplatesMutation,
} = classTemplateService;

export default classTemplateService;
